// BLOC 5 A FAIRE
import React, { Component } from "react"
import { Container, Col, Row } from "reactstrap"
import { withTranslation } from 'react-i18next'
import LazyLoad from 'react-lazy-load'




class LienEntreMicrobioteEtSante extends Component {



    render() {
        const t = this.props.t

        return (
            <>
                {/* Le lien entre Microbiote et la Santé */}
                <div className="gradiant-bot-gray px-3">
                    <Container className="my-5 py-0 py-md-3">
                        <h2 className="mb-5 second-title dark-blue small-underline">{t("microbiota|Le lien entre le microbiote et la santé")}</h2>
                        <Row>
                            <Col className="pr-lg-0 text-justify" md={6}>
                                    <p>{t("microbiota|LienMicroSante-1")}</p>
                                    <p>{t("microbiota|LienMicroSante-2")}</p>
                                    <p>{t("microbiota|LienMicroSante-3")}</p>
                                    <p>{t("microbiota|LienMicroSante-4-0")}<a href="https://blog.nahibu.com/stanislav-dusko-ehrlich-microbiologiste/" target="_blank" rel="noopener noreferrer">{t("microbiota|LienMicroSante-4-1")}</a>{t("microbiota|LienMicroSante-4-2")}</p>
                                    <p>{t("microbiota|LienMicroSante-5")}</p>
                            </Col>
                            <Col className="margin-auto" md={6}>
                                <div className="mb-5 ml-0 ml-md-5 video-responsive">
                                    <LazyLoad debounce={false}>
                                        <iframe title="Pr Stanislav Dusko Ehrlich" style={{ borderRadius: "10px", border: "2px solid var(--dark-blue)" }} src="https://www.youtube.com/embed/ajB6fg6D6jY" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                                    </LazyLoad>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}

export default withTranslation()(LienEntreMicrobioteEtSante)
